// Which pin an artwork gets. Kept pure and separate so the e2e test seam in
// MapComponent and the rendered marker can never disagree.
export function iconKindFor(item) {
  return item && item.archived ? 'gray' : 'red'
}

const escapeAttr = s =>
  String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))

/**
 * Markup for a thumbnail pin (Leaflet divIcon). `kind` colours the ring the
 * same way the PNG pins are coloured: red for live art, gray for archived.
 * The image is lazy: only pins that actually reach the DOM fetch a photo.
 */
export function pinHtml(kind, photoUrl, selected = false, hot = false) {
  const classes = ['aa-pin', `aa-pin--${kind}`]
  if (selected) classes.push('aa-pin--selected')
  else if (hot) classes.push('aa-pin--hot')
  return (
    `<div class="${classes.join(' ')}">` +
      `<div class="aa-pin__inner"><img loading="lazy" alt="" src="${escapeAttr(photoUrl)}"></div>` +
    `</div>`
  )
}

/**
 * Markup for a cluster bubble (markercluster iconCreateFunction). With a photo
 * from one of its members the group reads as art rather than as a number,
 * which is what makes the coverage zooms worth looking at.
 */
export function clusterHtml(count, photoUrl) {
  if (!photoUrl) {
    return `<div class="aa-cluster aa-cluster--plain"><span class="aa-cluster__count">${count}</span></div>`
  }
  return (
    `<div class="aa-cluster">` +
      `<img loading="lazy" alt="" src="${escapeAttr(photoUrl)}">` +
      `<span class="aa-cluster__count">${count}</span>` +
    `</div>`
  )
}
